import { emailValid, required, minLength } from "@/services/ValidatorService";

export const userLoginForm = {
  email: {
    value: "",
    props: {
      outline: true,
      "single-line": true,
      "prepend-inner-icon": "fas fa-envelope",
      label: "Correo electrónico",
      rules: [emailValid, required]
    }
  },
  password: {
    value: "",
    props: {
      outline: true,
      "single-line": true,
      "prepend-inner-icon": "fas fa-lock",
      label: "Password",
      rules: [required, minLength(8)],
      type: "password"
    }
  }
};
